// extracted by mini-css-extract-plugin
module.exports = {"company":"CompanyInfoText_company__2PWX0","company__tel":"CompanyInfoText_company__tel__1hevx","company__hour":"CompanyInfoText_company__hour__3o_Mj"};